import { render, staticRenderFns } from "./sellBillsPayment.vue?vue&type=template&id=2faf82ec"
import script from "./sellBillsPayment.vue?vue&type=script&lang=js"
export * from "./sellBillsPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports